import React, { useMemo } from 'react';
import { PlanOmnibusBalanceReportIcon } from '@common-fe/common-fe';

import { ROUTES } from '@/common';

import { useFavoriteReportHandler } from '../../hooks';
import { ReportTypeKeys } from '../../report.types';
import ReportCardBase, { ReportCardBaseProps } from '../ReportCardBase';

interface Props extends ReportCardBaseProps {}
const TEST_ID = 'plan-omnibus-balance-report-card';
const PlanOmnibusBalanceReportCard: React.FC<Props> = ({ isFavoriteMode }) => {
  const childrenNode = useMemo(() => {
    return null;
  }, []);
  const { isFavorite, handleToggleReportKey } = useFavoriteReportHandler(ReportTypeKeys.PlanOmnibusBalance);

  return (
    <ReportCardBase
      isWideMode={isFavoriteMode}
      url={ROUTES.PLAN_OMNIBUS_BALANCE_REPORT}
      isFavorite={isFavorite}
      testId={TEST_ID}
      onChangeFavorite={handleToggleReportKey}
      icon={
        <PlanOmnibusBalanceReportIcon
          size={isFavoriteMode ? '50px' : '40px'}
          color={isFavoriteMode ? 'iconAccent' : 'iconDisabled'}
        />
      }
      title="Plan Omnibus Balance"
      description="View all transactions affecting a single plan’s omnibus balance. Available for contribution-based funding and prefund spenddown plans"
    >
      {childrenNode}
    </ReportCardBase>
  );
};
export default PlanOmnibusBalanceReportCard;
